<template>
  <v-dialog v-model="dialog" class="dialog-wrapper" width="650px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        color="primary"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-container fluid>
      <v-card outlined class="p-3" :elevation="$getCardOptions('elevation')">
        <v-card-title class="p-0">
          <v-spacer></v-spacer>
          <v-btn class="ml-auto" :rounded="$getPrimaryButton('rounded')"
                :color="$getPrimaryButton('color2')" @click="dialog = false" :disabled="false"
                :loading="loading" icon large>
                <v-icon large>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title class="pt-0">
          <section-header first="Editar" second="registro de Anticipo" />
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <label class="input-field--label"> Año: </label>
            <v-select
              v-model="formData.year"
              :items="yearOptions"
              placeholder="Seleccionar año"
              :color="$getColor('vuetifyColor1')"
              outlined
              prepend-inner-icon="mdi-calendar"
              :rules="[v => !!v || 'El año es requerido']"
            ></v-select>
            <label class="input-field--label"> Mes: </label>
            <v-select
              v-model="formData.month"
              :items="monthOptions"
              placeholder="Seleccionar mes"
              :color="$getColor('vuetifyColor1')"
              outlined
              prepend-inner-icon="mdi-calendar"
              :rules="[v => !!v || 'El mes es requerido']"
            ></v-select>
            <label class="input-field--label"> Cantidad (€): </label>
            <v-text-field
              v-model="formData.amount"
              placeholder="Cantidad"
              type="number"
              max="700"
              :color="$getColor('vuetifyColor1')"
              outlined
              prepend-inner-icon="paid"
              :rules="[
                v => !!v || 'La cantidad es requerida',
                v => (v && v <= 700) || 'La cantidad máxima es 700'
              ]"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            text
            @click="deleteConfirmDialog = true"
          >
            Eliminar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            :rounded="$getPrimaryButton('rounded')"
            :disabled="!valid"
            :outlined="$getPrimaryButton('outlined')"
            :color="$getPrimaryButton('color')"
            large
            @click="editEntry"
            :loading="loading"
          >
            Guardar cambios
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="3000"
      color="error"
      top
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="deleteConfirmDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmar eliminación</v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar este registro?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="deleteConfirmDialog = false" :disabled="deleteLoading">
            Cancelar
          </v-btn>
          <v-btn color="error" text @click="confirmDeleteEntry" :loading="deleteLoading">
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric, maxValue } from 'vuelidate/lib/validators';
import SectionHeader from '@/components/Headers/SectionHeader.vue';
import N3Service from '@/services/n3.service';

export default {
  name: 'edit-n3-entry',
  props: {
    entry: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    workerId: {
      required: false,
    },
  },
  components: {
    SectionHeader,
  },
  data: () => ({
    mixins: [validationMixin],
    dialog: false,
    deleteConfirmDialog: false,
    loading: false,
    deleteLoading: false,
    valid: false,
    formData: {
      year: null,
      month: null,
      amount: null,
    },
    snackbar: false,
    snackbarText: '',
    yearOptions: [
      new Date().getFullYear(),
      new Date().getFullYear() + 1,
    ],
    monthOptions: [
      { text: 'Enero', value: 1 }, { text: 'Febrero', value: 2 }, { text: 'Marzo', value: 3 },
      { text: 'Abril', value: 4 }, { text: 'Mayo', value: 5 }, { text: 'Junio', value: 6 },
      { text: 'Julio', value: 7 }, { text: 'Agosto', value: 8 }, { text: 'Septiembre', value: 9 },
      { text: 'Octubre', value: 10 }, { text: 'Noviembre', value: 11 }, { text: 'Diciembre', value: 12 },
    ],
  }),
  validations() {
    return {
      formData: {
        year: { required },
        month: { required },
        amount: { required, numeric, maxValue: maxValue(700) },
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.formData.year = this.entry.year;
        this.formData.month = this.entry.month;
        this.formData.amount = this.entry.amount;
      }
    },
  },
  computed: {
    availableN3() {
      return this.$store.state.availableN3 === 'true';
    },
  },
  methods: {
    confirmDeleteEntry() {
      this.deleteLoading = true;
      const submitMethod = this.isAdmin
        ? N3Service.deleteAdminN3Entry(this.entry.id)
        : N3Service.deleteN3Entry(this.entry.id);
      submitMethod
        .then(() => {
          this.$emit('entryEdited');
          this.deleteConfirmDialog = false;
          this.dialog = false;
        })
        .catch((error) => {
          console.error(error);
          this.snackbarText = 'No se ha podido eliminar el registro.';
          this.snackbar = true;
        })
        .finally(() => { this.deleteLoading = false; });
    },
    editEntry() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const submitMethod = this.isAdmin
          ? N3Service.editAdminN3Entry(this.entry.id, this.formData.year, this.formData.month, this.formData.amount)
          : N3Service.editN3Entry(this.entry.id, this.formData.year, this.formData.month, this.formData.amount);

        submitMethod
          .then(() => {
            this.$emit('entryEdited');
            this.dialog = false;
          })
          .catch((error) => {
            console.error(error);
            if (error.response && error.response.status === 404) {
              this.snackbarText = 'No se ha podido editar el registro.';
              this.snackbar = true;
            }
          })
          .finally(() => { this.loading = false; });
      }
    },
  },
};
</script>
